import axios, { AxiosResponse } from 'axios';

export interface IZalozeniSluzbyResp {
    id: number;
    sluzba: string;
}

export const zalozeniFsluzbyApi = (sluzba: string) => {
    // sluzba napr F42, F18 etc
    return axios({
        method: 'POST',
        url: 'Sluzby/Zalozit',
        data: {
            sluzba: sluzba
        }
    }).then((resp: AxiosResponse<IZalozeniSluzbyResp>) => resp.data);
};
